import { apiClient } from '@shared/infrastructure/http';
import { tokenManager } from '@shared/infrastructure/security';

interface LigneLivrePaie {
  idEmploye: string;
  nom: string;
  prenoms: string;
  salaireBase: number;
  salaireBrut: number;
  cnssEmploye: number;
  cnssPatronal: number;
  its: number;
  vps: number;
  salaireNet: number;
  netAPayer: number;
}

interface LivrePaieDTO {
  lignes: LigneLivrePaie[];
  totaux: {
    salaireBase: number;
    salaireBrut: number;
    cnssEmploye: number;
    cnssPatronal: number;
    its: number;
    vps: number;
    salaireNet: number;
    netAPayer: number;
  };
}

interface LigneAudit {
  idLog: string;
  dateOperation: string;
  action: string;
  module: string;
  entityType?: string;
  entityId?: string;
}

interface AuditDTO {
  lignes: LigneAudit[];
  total: number;
}

const BASE = '/api/v1/paie/rapports';

export const rapportsApi = {
  livrePaie: (annee: number, mois: number) =>
    apiClient.get<LivrePaieDTO>(`${BASE}/livre-paie/${annee}/${mois}`).then(r => r.data!),

  exportComptable: (annee: number, mois: number) =>
    apiClient.get(`${BASE}/export-comptable/${annee}/${mois}`).then(r => r.data),

  audit: (params?: { mois?: number; annee?: number; typeOperation?: string; page?: number; pageSize?: number }) => {
    const qs = new URLSearchParams();
    if (params?.mois) qs.append('mois', String(params.mois));
    if (params?.annee) qs.append('annee', String(params.annee));
    if (params?.typeOperation) qs.append('typeOperation', params.typeOperation);
    if (params?.page) qs.append('page', String(params.page));
    if (params?.pageSize) qs.append('pageSize', String(params.pageSize));
    const url = qs.toString() ? `${BASE}/audit?${qs}` : `${BASE}/audit`;
    return apiClient.get<AuditDTO>(url).then(r => r.data!);
  },

  exporterEtatRemuneration: async (annee: number, mois: number) => {
    const headers: Record<string, string> = {};
    const authHeader = tokenManager.getAuthorizationHeader();
    if (authHeader) headers['Authorization'] = authHeader;

    const response = await fetch(`${BASE}/etat-remuneration/${annee}/${mois}`, { headers });
    if (!response.ok) throw new Error("Erreur lors du téléchargement de l'état de rémunération");

    const contentDisposition = response.headers.get('content-disposition') || '';
    const match = contentDisposition.match(/filename="?([^";\s]+)"?/);
    const filename = match?.[1] ?? `ETAT_REMUNERATION_${annee}_${String(mois).padStart(2, '0')}.xlsx`;
    const blob = await response.blob();
    return { blob, filename };
  },
};
